<template>
  <div class="row">
    <div class="col-lg-6">
    <div class="card"
    v-loading="loading"
    element-loading-text="Wird geladen..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-9">
            <p-button type="default" link style="float: left;" @click="navigateBack()" title="Zurück"><i class="bi bi-arrow-left" style="font-size: 16px;"></i></p-button><h5 class="card-title">{{ psaItem }} {{ psaSerialNumber }} <small class="text-muted" v-if="multiLocationMode == 1">({{psaLocation}})</small></h5>
          </div>
          <div class="col text-right">
            <p-button type="default" link @click="editPSA()" title="Bearbeiten" v-if="psaRole > 1"><i class="bi bi-pencil-square" style="font-size: 16px;"></i></p-button>
            <p-button type="default" link @click="changePSALocationDialog()" title="Standortzuordnung ändern" v-if="psaRole > 1 && multiLocationMode == 1"><i class="bi bi-pin-map" style="font-size: 16px;"></i></p-button>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12 pt-3">
          <div class="row">
            <div class="col-sm-3">
              <h6>Hersteller</h6>
            </div>
            <div class="col-sm-3">
              <p>{{psaManufacturer}}</p>
            </div>
            <div class="col-sm-3">
              <h6>Kategorie</h6>
            </div>
            <div class="col-sm-3">
              <p>{{psaType}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <h6>Seriennummer</h6>
            </div>
            <div class="col-sm-3">
              <p>{{psaSerialNumber}}</p>
            </div>
            <div class="col-sm-3">
              <h6>Eigene Nummer</h6>
            </div>
            <div class="col-sm-3">
              <p>{{psaOwnId}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <h6>Herstellung</h6>
            </div>
            <div class="col-sm-3">
              <p>{{psaProdDate}}</p>
            </div>
            <div class="col-sm-3">
              <h6>Inbetriebnahme</h6>
            </div>
            <div class="col-sm-3">
              <p>{{psaFirstUse}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <h6>Letzte Prüfung</h6>
            </div>
            <div class="col-sm-3">
              <p>{{psaLastMaintenance}}</p>
            </div>
            <div class="col-sm-3">
              <h6>Nächste Prüfung</h6>
            </div>
            <div class="col-sm-3">
              <p>{{psaNextMaintenance}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <h6>Ablegereif</h6>
            </div>
            <div class="col-sm-3">
              <p v-if="psaEOLReached == false">{{psaEOL}}</p>
              <p v-if="psaEOLReached == true" style="color: red !important;"><b>{{psaEOL}}</b></p>
            </div>
            <div class="col-sm-3">
              <h6>Status</h6>
            </div>
            <div class="col-sm-3">
              <el-tag
                  v-if="psaStatus === 'OK'"
                  type="success"
                  size="small"
                  disable-transitions>Einsatzbereit</el-tag>
                <el-tag
                  v-if="psaStatus === 'maintenance'"
                  type="warning"
                  size="small"
                  disable-transitions>Prüfung fällig</el-tag>
                <el-tag
                  v-if="psaStatus === 'NOK'"
                  type="danger"
                  size="small"
                  disable-transitions>Nicht einsatzbereit</el-tag>
                <el-tag
                  v-if="psaStatus === 'Removed'"
                  type="danger"
                  size="small"
                  disable-transitions>Ausgesondert</el-tag>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <h6>Anmerkungen</h6>
            </div>
            <div class="col-sm-9">
              <p style="white-space: pre-line;">{{psaDescription}}</p>
            </div>
          </div>
          <div class="row pt-3 mt-3 ml-0 mr-2 align-items-center ">
            <div class="col-lg pr-1"><p-button type="default" @click="navigateToSearch()" block title="Zurück zur Suche"><i class="bi bi-search"></i> Suche</p-button></div>
            <div class="col-lg pr-1"><p-button type="default" @click="showGAL()" :disabled="psaGalLink == ''" block title="GAL anzeigen"><i class="bi bi-file-text"></i> GAL</p-button></div>
            <div class="col-lg pr-1"><p-button type="default" @click="showIAPA()" block title="Warnungen IAPA anzeigen"><i class="bi bi-exclamation-diamond"></i> IAPA</p-button></div>
            <div class="col-lg pr-1"><p-button type="default" @click="showERCA()" block title="Warnungen ERCA anzeigen"><i class="bi bi-exclamation-diamond"></i> ERCA</p-button></div>

          </div>
          <div class="row ml-0 mr-2 pt-2 align-items-center">
            <div class="col-lg pr-1">
              <p-button type="success" @click="newMaintenance()" block class="mt-0" :disabled="role < 2 || psaRole < 2"><i class="bi bi-wrench"></i> Neue Überprüfung</p-button>
            </div>
            
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-9">
            <h6 class="card-title">Set-Komponenten</h6>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <div class="row">
            <el-table :data="psaComponents" empty-text="Keine Komponenten gefunden" :row-class-name="getComponentRowClass">
              <el-table-column
                prop="componentId"
                label="Serien-Nr."
                min-width="80"
                >
              </el-table-column>
              <el-table-column
                prop="componentName"
                label="Bezeichnung" min-width="110">
              </el-table-column>
              <el-table-column
                prop="componentEOLDate"
                label="Ablegereif" min-width="60">
                <template slot-scope="scope">
                  <span v-if="scope.row.componentEOLReached" style="color: red !important;"><b>{{ scope.row.componentEOLDate }}</b></span>
                  <span v-else>{{ scope.row.componentEOLDate }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label=""
                align="right"
                min-width="80"
                >
                <template slot-scope="scope">
                  <p-button type="default" size="sm" @click="editComponent(scope.row.componentId, scope.row.componentName, scope.row.key, scope.row.componentMaxUsage, scope.row.componentProdDate)" class="mr-1" title="Komponente bearbeiten" :disabled="role < 2 || psaRole < 2 || scope.row.componentReplaced == true"><i class="bi bi-pencil"></i></p-button>
                  <p-button type="default" size="sm" @click="replaceComponent(scope.row.componentName, scope.row.componentId, scope.row.key, scope.row.componentEOLDate)" class="mr-1" title="Komponente ersetzen" :disabled="role < 2 || psaRole < 2 || scope.row.componentReplaced == true"><i class="bi bi-arrow-repeat"></i></p-button>
                  <p-button type="danger" size="sm" @click="removeComponent(scope.row.key)" title="Komponente löschen" :disabled="role < 2 || psaRole < 2"><i class="bi bi-trash"></i></p-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="row ml-1 mr-2 mt-3 float-right">
            <p-button type="default" @click="newComponent()" class="mt-0" title="Komponente hinzufügen" :disabled="role < 2 || psaRole < 2"><i class="bi bi-plus-circle" style="font-size: 16px;"></i></p-button>
          </div>
        </div>
      </div>
    </div>
    </div>
            <div class="col-lg-6">
          <time-line type="">
            <time-line-item
              :class="index % 2 == 1 ? 'timeline-inverted' : 'timeline'"
              v-for="(maintenance, index) in psaMaintenanceHistory"
              :key="maintenance.key"
              :badgeType="maintenance.maintenanceResult == 'Ausgesondert' ? 'danger' : 'success'"
              badgeIcon="timeline-icon bi bi-wrench"
            >
            <badge slot="header" type="danger" v-if="maintenance.maintenanceResult == 'Ausgesondert'">{{ maintenance.maintenanceDate }}</badge>
            <badge slot="header" type="success" v-else><b>{{ maintenance.maintenanceDate }}</b></badge>
            <p slot="content" style="white-space: pre-line;" class="pt-3">
              <b>Ergebnis der Prüfung:</b><br> {{ maintenance.maintenanceResult}}</p>
            <p slot="content" style="white-space: pre-line;" class="pb-2">
              <b>Anmerkungen:</b><br>{{ maintenance.maintenanceNote }}</p>
            <small slot="footer" class="text-muted"><i class="bi bi-person-fill"></i> {{ maintenance.maintenanceTrainer }} ({{ maintenance.maintenanceType }})</small>
          </time-line-item>
          <time-line-item
              class="timeline"
              badgeType="default"
              badgeIcon="timeline-icon bi bi-play-fill"
            >
            <p slot="content"><b>Inbetriebnahme:</b><br>{{ psaFirstUse }}</p>
          </time-line-item>
          <time-line-item
              class="timeline-inverted"
              badgeType="default"
              badgeIcon="timeline-icon bi bi-house-gear"
            >
            <p slot="content"><b>Herstellung:</b><br>{{ psaProdDate }}</p>
          </time-line-item>
        </time-line>
        </div>

      <modal :show.sync="showNewMaintenanceModal" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0">Überprüfung {{ psaItem }} {{ psaSerialNumber }}</h5>
      <div class="row">
        <div class="col-md">
          <label class="pt-1">Datum:</label>
          <el-date-picker v-model="newMaintenanceDate" type="date" placeholder="Datum der Überprüfung" :picker-options="pickerOptionsMaintenance" :clearable="false" format="dd.MM.yyyy" disabled></el-date-picker>
        </div>
        <div class="col">
          <label class="pt-1">Mitarbeiter:</label>
          <el-input v-model="newMaintenanceTrainer" prefix-icon="el-icon-user-solid" disabled></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Grund der Überprüfung:</label>
          <el-radio-group v-model="newMaintenanceType" block>
            <el-radio-button label="Planmäßige Prüfung" block></el-radio-button>
            <el-radio-button label="Außerplanmäßige Prüfung"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Kommentare / durchgeführte Reparaturen / Beobachtungen:</label>
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 8}" placeholder="Kommentare/durchgeführte Reparaturen/Beobachtungen..." v-model="newMaintenanceNote"></el-input>
        </div>
      </div>
      <div class="row pt-4">
        <div class="col">
          <el-checkbox v-model="newMaintenanceGeneralCheck" class="mb-0"><b>Allgemeine Überprüfung ist erfolgt</b></el-checkbox>
          <ul>
            <li>Kennzeichnung vorhanden und lesbar</li>
            <li>GAL vorhanden</li>
            <li>PSA ist innerhalb der Lebensdauerangabe des Herstellers</li>
            <li>Keine Rückrufe zur PSA vorhanden </li>
          </ul>
          <el-checkbox v-model="newMaintenanceFunctionCheck"><b>Sicht- und Funktionsprüfung gemäß Herstellerangaben durchgeführt</b></el-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4"><b>Ergebnis der Überprüfung:</b></label>
          <el-radio-group v-model="newMaintenanceResult">
            <el-radio label="Einwandfrei & einsatzbereit"></el-radio>
            <el-radio label="Vorübergehend nicht einsatzbereit"></el-radio>
            <el-radio label="Ausgesondert & vernichtet"></el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Nächste Prüfung:</label>
          <el-date-picker v-model="newMaintenanceNextDate" type="month" placeholder="Nächste Wartung" :picker-options="pickerOptionsNextMaintenance" :clearable="false" format="MMMM yyyy"></el-date-picker>
        </div>

      </div>
      
      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showNewMaintenanceModal=false">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="saveMaintenance()" :disabled="newMaintenanceResult == '' || newMaintenanceType == '' || newMaintenanceGeneralCheck != true || newMaintenanceFunctionCheck != true">Speichern</p-button>
        </div>
      </template>
    </modal>

    <modal :show.sync="componentDialogVisible" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0" v-if="componentMode=='new'">Set-Komponente hinzufügen</h5>
      <h5 slot="header" class="title mb-0" v-else-if="componentMode=='replace'">Set-Komponente ersetzen</h5>
      <h5 slot="header" class="title mb-0" v-else>Set-Komponente bearbeiten</h5>
      <div class="row">
        <div class="col">
          <label class="pt-4">Serien-Nr.:</label>
          <el-input v-model="componentEditId" prefix-icon="el-icon-key"></el-input>
          <span class="text-muted pt-1" v-if="componentMode == 'replace'"><i>Ersetzt {{ componentReplacedSerial }}</i></span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Bezeichnung:</label>
          <el-input v-model="componentEditName" prefix-icon="el-icon-tickets"></el-input>
          <span class="text-muted pt-1" v-if="componentMode == 'replace'"><i>Ersetzt {{ componentReplacedName }}</i></span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Herstellungsdatum:</label>
          <el-date-picker v-model="componentEditProdDate" type="month" placeholder="Herstellungsdatum" :picker-options="pickerOptionsProdDate" :clearable="false" format="MMMM yyyy"></el-date-picker>
        </div>
        <div class="col">
          <label class="pt-4">Max. Lebensdauer (Jahre):</label>
          <el-input-number v-model="componentEditMaxUsage" :min="1" :max="30" class="w-100"></el-input-number>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="componentDialogVisible=false">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link v-if="componentMode == 'new'" @click="addComponent()" :disabled="componentEditId == '' || componentEditName == ''">Hinzufügen</p-button>
          <p-button type="success" link v-else-if="componentMode == 'replace'" @click="replaceComponentSave()" :disabled="componentEditId == '' || componentEditName == ''">Ersetzen</p-button>
          <p-button type="success" link v-else @click="updateComponent()" :disabled="componentEditId == '' || componentEditName == ''">Speichern</p-button>
        </div>
      </template>
    </modal>

    <modal :show.sync="showEditPsaModal" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0">Bearbeiten</h5>
      <div class="row">
        <div class="col">
          <label class="pt-4">Bezeichnung</label>
          <el-input v-model="psaItem"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Serien-Nummer:</label>
          <el-input v-model="psaSerialNumber" prefix-icon="el-icon-key"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Eigene Nummer:</label>
          <el-input v-model="psaOwnId" prefix-icon="el-icon-key"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Hersteller:</label>
          <el-select v-model="psaManufacturer" placeholder="Hersteller auswählen" clearable>
            <el-option v-for="manufacturer in manufacturers" :value=manufacturer :label=manufacturer :key=manufacturer></el-option>
          </el-select>
        </div>
        <div class="col">
          <label class="pt-4">Kategorie:</label>
          <el-select v-model="psaType" placeholder="Kategorie auswählen" clearable>
            <el-option v-for="cat in psaCategories" :value=cat.psaCatName :label=cat.psaCatName :key=cat.psaCatName></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Herstellung:</label>
          <el-date-picker v-model="psaProdDate" type="month" placeholder="Herstellungsdatum" :picker-options="pickerOptions" :clearable="false" format="MMMM yyyy"></el-date-picker>
        </div>
        <div class="col">
          <label class="pt-4">Inbetriebnahme:</label>
          <el-date-picker v-model="psaFirstUse" type="month" placeholder="Inbetriebnahme" :picker-options="pickerOptions" :clearable="false" format="MMMM yyyy"></el-date-picker>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Lebensdauer (Jahre):</label><br>
          <el-input-number style="text-align: center" v-model="psaEOLyears" :min="0" :max="30"></el-input-number>
        </div>
        <div class="col" v-if="multiLocationMode == 1">
          <label class="pt-4">Standort:</label>
          <el-select v-model="psaLocation" placeholder="Standort">
            <el-option v-for="location in locations"
                  :key="location.key"
                  :label="location.name"
                  :value="location.key"
                ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">GAL-Link:</label>
          <el-input v-model="psaGalLink" prefix-icon="bi bi-link-45deg" clearable></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Anmerkungen:</label>
          <textarea class="form-control px-2" rows="3" v-model="psaDescription"></textarea>
        </div>
      </div>
      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showEditPsaModal=false">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="savePsa()" :disabled="psaItem == '' || psaSerialNumber == '' || psaProdDate == '' || psaFirstUse == '' || psaManufacturer == '' || psaType == '' || psaLocation == ''">Speichern</p-button>
        </div>
      </template>
    </modal>

    <!-- Change PSA Location Dialog -->
    <el-dialog title="Standortzuordnung ändern" :visible.sync="changePSALocationDialogVisible" :close-on-click-modal="false" width="700px">
      <el-form label-position="top">
        <el-form-item label="Titel" required>
          <el-select v-model="psaLocationId" placeholder="Standort auswählen" style="width: 100%; margin-top: 10px;">
            <el-option v-for="location in locations"
                  :key="location.key"
                  :label="location.name"
                  :value="location.key"
                ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <p-button @click="changePSALocationDialogVisible = false">Abbrechen</p-button>
        <p-button type="primary" @click="changePSALocation">Standortzurodnung ändern</p-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Table, TableColumn, Input, InputNumber, Loading, Popover, Tag, Select, Option, MessageBox, Dialog, Form, FormItem} from "element-ui";
import { TimeLine, TimeLineItem, Badge, Modal } from "src/components/UIComponents";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
import locations from "../../../../locationStore";
import psaData from "../../../../../psa.json";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Loading);
Vue.use(Tag)

export default {
  components: {
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    TimeLine,
    TimeLineItem,
    Badge,
    Modal,
    MessageBox,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
  },

  data() {
    return {
      psaId: 0,
      psaOwnId: "",
      psaItem: "",
      psaManufacturer: "",
      psaSerialNumber: "",
      psaStatus: "",
      psaLastMaintenance: "",
      psaNextMaintenance: "",
      psaType: "",
      psaProdDate: "",
      psaFirstUse: "",
      psaLocationId: "",
      psaLocation: locations.getters.locations.locations[0]['key'],
      psaEOL: 0,
      psaEOLyears: 0,
      psaEOLReached: false,
      psaDescription: "",
      psaMaintenanceHistory: [],
      psaComponents: [],
      psaGalLink: "",
      psaLinks: [],
      psaCategories: [],
      showNewMaintenanceModal: false,
      showEditPsaModal: false,
      changePSALocationDialogVisible: false,
      loading: true,
      newMaintenanceNote: "",
      newMaintenanceDate: moment(),
      newMaintenanceTrainer: store.getters.user.data.displayName,
      newMaintenanceNextDate: moment().add(1, "years"),
      newMaintenanceType: "",
      newMaintenanceResult: "",
      newMaintenanceGeneralCheck: true,
      newMaintenanceFunctionCheck: true,
      componentDialogVisible: false,
      componentMode: "",
      componentEditId: "",
      componentEditName: "",
      componentEditMaxUsage: 10,
      componentEditEOLDate: "",
      componentEditProdDate: "",
      componentEditKey: "",
      componentEditReplaced: false,
      multiLocationMode: process.env.VUE_APP_MULTIPLE_LOCATIONS,
      locations: locations.getters.locations.locations,
      role: store.getters.userrole,
      psaRole: store.getters.psaRole,
      manufacturers: psaData.manufacturers.map(manufacturer => manufacturer.name),
      pickerOptionsProdDate: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          firstDayOfWeek: 1,
          shortcuts: []
        },
      pickerOptionsNextMaintenance: {
          disabledDate(time) {
            return time.getTime() < Date.now();
          },
          firstDayOfWeek: 1,
          shortcuts: [{
            text: '1 Monat',
            onClick(picker) {
              picker.$emit('pick', moment().add(1, "months"));
            }
          }, {
            text: '3 Monate',
            onClick(picker) {
              picker.$emit('pick', moment().add(3, "months"));
            }
          }, {
            text: '6 Monate',
            onClick(picker) {
              picker.$emit('pick', moment().add(6, "months"));
            }
          }, {
            text: '12 Monate',
            onClick(picker) {
              picker.$emit('pick', moment().add(12, "months"));
            }
          }]
        },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        firstDayOfWeek: 1,
        shortcuts: []
      },
      pickerOptionsMaintenance: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          firstDayOfWeek: 1,
          shortcuts: []
        },
    };
  },
  created() {
    if(store.getters.psaRole == "0") {
      MessageBox.alert(
        "Zugriff verweigert.",
        {
          confirmButtonText: "OK",
          type: "error",
          callback: (action) => {
            router.push({ name: 'Overview' })
          },
        }
      );
    } 
    this.psaId = this.$route.params.psaId
    moment.locale("de");
    this.loadPsaItem()
    store.watch(
      (state) => state.userlocation,
      () => {
        this.loadPsaItem();
      }
    );
  },
  methods: {
    navigateToSearch() {
      router.push({ name: "PsaSearch" });
    },
    showGAL() {
      window.open(this.psaGalLink, "_blank");
    },
    showERCA() {
      window.open("https://www.erca.uk/index.php/de/publikationen/sicherheit/53-sicherheits-warnungen", "_blank");
    },
    showIAPA() {
      window.open("https://iapa.cc/protection/sicherheitsmeldungen/", "_blank");
    },
    newMaintenance() {
      this.showNewMaintenanceModal = true;
    },
    navigateBack() {
      router.go(-1);
    },
    loadPsaCategories() {
      const psaCatRef = db.collection("psaCategories");
      psaCatRef.orderBy("Name").onSnapshot((snapshotChange) => {
        this.psaCategories = [];
        snapshotChange.forEach((doc) => {
          this.psaCategories.push({
            key: doc.id,
            psaCatName: doc.data().Name,
          });
        });
      });
    },
    loadPsaItem() {
      // get PSA data from firebase
      const psaRef = db.collection("psa");
      psaRef.doc(this.psaId).get().then((doc) => {
        var location = ""
        for (var loc of this.locations) {
          if (loc.key == doc.data().locationID) {
            location = loc.name
          }
        }
        this.psaItem = doc.data().Item
        this.psaOwnId = doc.data().OwnId || ""
        this.psaManufacturer = doc.data().Manufacturer
        this.psaSerialNumber = doc.data().SerialNumber

        if (doc.data().ProdDate != null) {
          this.psaProdDate = moment(new Date(doc.data().ProdDate.seconds * 1000)).format("MMM yyyy").toString()
        } else {
          this.psaProdDate = moment(new Date('2000-01-01')).format("MMM yyyy").toString()
        }
        if (doc.data().FirstUse != null) {
          this.psaFirstUse = moment(new Date(doc.data().FirstUse.seconds * 1000)).format("MMM yyyy").toString()
        } else {
          this.psaFirstUse = moment(new Date('2000-01-01')).format("MMM yyyy").toString()
        }
        if(doc.data().LastMaintenance != null) {
          this.psaLastMaintenance = moment(new Date(doc.data().LastMaintenance.seconds * 1000)).format("MMM yyyy").toString()
        } else {
          this.psaLastMaintenance = moment(new Date('2000-01-01')).format("MMM yyyy").toString()
        }
        if(doc.data().NextMaintenance != null) {
          this.psaNextMaintenance = moment(new Date(doc.data().NextMaintenance.seconds * 1000)).format("MMM yyyy").toString()
        } else {
          this.psaNextMaintenance = moment(new Date('2000-01-01')).format("MMM yyyy").toString()
        }
        var status = doc.data().Status;
        if (status == 'maintenance') {
          status = "maintenance";
        } else if (status == 'OK' && moment().isSameOrAfter(moment(new Date(doc.data().NextMaintenance)))) {
          status = "maintenance";
        } else if (status == 'OK' && moment().isBefore(moment(new Date(doc.data().NextMaintenance)))) {
            status = "OK";
        }
        this.psaStatus = status
        this.psaType = doc.data().Type
        this.psaLocationId = doc.data().locationID
        this.psaLocation = location
        this.psaGalLink = doc.data().GalLink || ""
        this.psaDescription = doc.data().Description || "-"
        this.psaEOLyears = doc.data().EOL || 0
        this.psaEOL = moment(new Date(doc.data().ProdDate.seconds * 1000)).add(doc.data().EOL, "years").format("MMM yyyy").toString()
        if(moment().add(6, "months").isSameOrAfter(moment(new Date(doc.data().ProdDate.seconds * 1000)).add(doc.data().EOL, "years"))) {
          this.psaEOLReached = true
        }

        this.psaMaintenanceHistory = []
        db.collection("psa").doc(this.psaId).collection("maintenance").orderBy("Date", "desc").get().then((snapshot) => {
          snapshot.forEach((doc) => {
            this.psaMaintenanceHistory.push({
              key: doc.id,
              maintenanceDate: moment(new Date(doc.data().Date.seconds * 1000)).format("DD. MMMM yyyy").toString(),
              maintenanceType: doc.data().Type,
              maintenanceResult: doc.data().Result,
              maintenanceNote: doc.data().Note || "-",
              maintenanceTrainer: doc.data().Trainer,
            })
          });
        });

        this.psaComponents = []
        db.collection("psa").doc(this.psaId).collection("components").get().then((snapshot) => {
          snapshot.forEach((doc) => {
            let eol = ""
            if (doc.data().EOLDate != null) {
              eol = moment(new Date(doc.data().EOLDate.seconds * 1000)).format("MMM yyyy").toString()
            } else {
              eol = ""
            }
            if (doc.data().EOLDate != null && moment().isSameOrAfter(moment(new Date(doc.data().EOLDate.seconds * 1000)))) {
              this.psaStatus = "maintenance"
            }
            this.psaComponents.push({
              key: doc.id,
              componentId: doc.data().ComponentID,
              componentName: doc.data().Name,
              componentReplaced: doc.data().Replaced || false,
              componentEOLDate: eol,
              componentEOLReached: doc.data().EOLDate != null && moment().isSameOrAfter(moment(new Date(doc.data().EOLDate.seconds * 1000))),
              componentMaxUsage: doc.data().MaxUsage || 0,
              componentProdDate: doc.data().ProdDate != null ? moment(new Date(doc.data().ProdDate.seconds * 1000)).format("MMM yyyy").toString() : "",
            })
          });
        });
        this.loadPsaCategories();
        this.loading = false
      });
    },
    editPSA() {
      this.showEditPsaModal = true
    },
    savePsa() {
      db.collection("psa").doc(this.psaId).update({
        Item: this.psaItem,
        OwnId: this.psaOwnId,
        SerialNumber: this.psaSerialNumber,
        Manufacturer: this.psaManufacturer,
        Type: this.psaType,
        ProdDate: new Date(this.psaProdDate),
        FirstUse: new Date(this.psaFirstUse),
        EOL: this.psaEOLyears,
        locationID: this.psaLocationId,
        GalLink: this.psaGalLink,
        Description: this.psaDescription,
        LastUpdate: new Date(),
      }).then(() => {
        this.showEditPsaModal = false
        this.loadPsaItem()
        this.$notify({
          message: "PSA wurde erfolgreich gespeichert!",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      }).catch(() => {
        this.$notify({
          message: "Fehler beim Speichern der PSA! Bitte Internetverbindung prüfen.",
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 10000,
        });
      });
    },
    newComponent() {
      this.componentEditId = ""
      this.componentEditName = ""
      this.componentEditMaxUsage = 10
      this.componentMode = "new"
      this.componentDialogVisible = true
    },
    replaceComponent(componentName, serial, key, eol) {
      this.componentEditId = ""
      this.componentEditName = ""
      this.componentEditMaxUsage = 10
      this.componentMode = "replace"
      this.componentDialogVisible = true
      this.componentReplacedId = key
      this.componentReplacedName = componentName
      this.componentReplacedSerial = serial
    },
    editComponent(componentId, componentName, key, maxUsage, prodDate) {
      this.componentEditId = componentId
      this.componentEditName = componentName
      this.componentEditKey = key
      this.componentEditMaxUsage = maxUsage
      this.componentEditProdDate = prodDate
      this.componentMode = "edit"
      this.componentDialogVisible = true
    },
    addComponent() {
      db.collection("psa").doc(this.psaId).collection("components").add({
        ComponentID: this.componentEditId,
        Name: this.componentEditName,
        Replaced: false,
        MaxUsage: this.componentEditMaxUsage,
        EOLDate: this.componentEditProdDate != "" ? moment(this.componentEditProdDate).add(this.componentEditMaxUsage, 'years').toDate() : null,
        ProdDate: this.componentEditProdDate != "" ? new Date(this.componentEditProdDate) : null,
        Created: new Date(),
      }).then(() => {
        this.componentEditId = ""
        this.componentEditName = ""
        this.componentEditKey = ""
        this.componentEditMaxUsage = 10
        this.componentEditProdDate = ""
        this.componentDialogVisible = false
        this.loadPsaItem()
      });
    },
    removeComponent(componentId) {
      MessageBox.confirm(
        "Soll die Komponente wirklich gelöscht werden?",
        "Warnung",
        {
          confirmButtonText: "Löschen",
          cancelButtonText: "Abbrechen",
          type: "warning",
          callback: (action) => {
            if (action == "confirm") {
              db.collection("psa").doc(this.psaId).collection("components").doc(componentId).delete().then(() => {
                this.loadPsaItem()
              });
            }
          },
        }
      );
    },
    updateComponent() {
      db.collection("psa").doc(this.psaId).collection("components").doc(this.componentEditKey).update({
        ComponentID: this.componentEditId,
        Name: this.componentEditName,
        Replaced: false,
        MaxUsage: this.componentEditMaxUsage,
        EOLDate: this.componentEditProdDate != "" ? moment(this.componentEditProdDate).add(this.componentEditMaxUsage, 'years').toDate() : null,
        ProdDate: this.componentEditProdDate != "" ? new Date(this.componentEditProdDate) : null,
        LastUpdate: new Date(),
      }).then(() => {
        this.componentEditId = ""
        this.componentEditName = ""
        this.componentEditKey = ""
        this.componentEditMaxUsage = 10
        this.componentEditProdDate = ""
        this.componentDialogVisible = false
        this.loadPsaItem()
      });
    },
    replaceComponentSave() {
      db.collection("psa").doc(this.psaId).collection("components").doc(this.componentReplacedId).update({
        Replaced: true,
        LastUpdate: new Date(),
      }).then(() => {
        db.collection("psa").doc(this.psaId).collection("components").add({
          ComponentID: this.componentEditId,
          Name: this.componentEditName,
          Replaced: false,
          EOLDate: this.componentEditEOL,
          ProdDate: this.componentEditProdDate != "" ? new Date(this.componentEditProdDate) : null,
          Created: new Date(),
        }).then(() => {
          this.componentEditId = ""
          this.componentEditName = ""
          this.componentEditKey = ""
          this.componentEditEOL = 10
          this.componentEditProdDate = ""
          this.componentDialogVisible = false
          this.componentReplacedId = ""
          this.componentReplacedName = ""
          this.componentReplacedSerial = ""
          this.loadPsaItem()
        });
      });
    },
    changePSALocationDialog() {
      this.changePSALocationDialogVisible = true
    },
    changePSALocation() {
      db.collection("psa").doc(this.psaId).update({
        locationID: this.psaLocationId,
        LastUpdate: new Date(),
      }).then(() => {
        this.changePSALocationDialogVisible = false
        this.loadPsaItem()
        this.$notify({
          message: "Standortzuordnung wurde erfolgreich geändert!",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      }).catch(() => {
        this.$notify({
          message: "Fehler beim Ändern des Standorts! Bitte Internetverbindung prüfen.",
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 10000,
        });
      });
    },
    saveMaintenance() {
      db.collection("psa").doc(this.psaId).collection("maintenance").add({
          Date: new Date(this.newMaintenanceDate),
          Note: this.newMaintenanceNote,
          Trainer: this.newMaintenanceTrainer,
          NextDate: new Date(this.newMaintenanceNextDate),
          Type: this.newMaintenanceType,
          Result: this.newMaintenanceResult,
          Timestamp: new Date(),
        })
        .then(() => {
          let status = "OK"
          if (this.newMaintenanceResult == "Ausgesondert & vernichtet") {
            status = "Removed"
          } else if (this.newMaintenanceResult == "Vorübergehend nicht einsatzbereit") {
            status = "NOK"
          }
          db.collection("psa").doc(this.psaId).update({
            LastMaintenance: new Date(this.newMaintenanceDate),
            NextMaintenance: new Date(this.newMaintenanceNextDate),
            Status: status,
          }).then(() => {
            this.newMaintenanceNote = ""
            this.newMaintenanceDate = moment()
            this.newMaintenanceTrainer = store.getters.user.data.displayName
            this.newMaintenanceNextDate = moment().add(1, "years")
            this.newMaintenanceType = ""
            this.newMaintenanceResult = ""
            this.showNewMaintenanceModal = false
            this.loadPsaItem()
            this.$notify({
              message: "Überprüfung wurde erfolgreich gespeichert!",
              icon: "fa fa-check-circle",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "success",
              showClose: true,
              timeout: 5000,
            });
          }).catch(() => {
            this.$notify({
              message: "Fehler beim Speichern der Überprüfung! Bitte Internetverbindung prüfen.",
              icon: "fa fa-exclamation-circle",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
              showClose: true,
              timeout: 10000,
            });
          });
        }).catch(() => {
          this.$notify({
            message: "Fehler beim Speichern der Überprüfung! Bitte Internetverbindung prüfen.",
            icon: "fa fa-exclamation-circle",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
            showClose: true,
            timeout: 10000,
          });
        });
    },
    getComponentRowClass(row, index) {
      if (row.row.componentReplaced == true) {
        return 'table-replaced';
      }
      return '';
    },
  },
};
</script>
<style>
.el-tag {
  color: white !important;
  margin-left: 0px !important;
}
.timeline-icon {
  line-height: 2.1;
  width: 25px;
  text-align: center;
  font-size: 22px;
}
.el-descriptions-item__label {
  font-weight: bold;
}
.timeline-heading {
  margin-bottom: 0px !important;
}
.el-radio-button__inner {
  width: 100% !important;
}
.el-radio-group {
  width: 100% !important;
}
.el-radio-button {
  width: 50% !important;
}
.el-checkbox {
  white-space: break-spaces !important;
}
.el-radio-button__inner {
  white-space: break-spaces !important;
}
.table-replaced {
  text-decoration: line-through;
}
</style>
